import { ScrollLines, Reveal, Eyebrow } from '@/components/Reveal';
import { TURMERIC_GRADES } from '@/data/spices';

export default function GradeGuide() {
  return (
    <section className="border-y border-white/10 bg-coal/30" data-testid="grade-guide">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
        <div className="grid gap-12 md:grid-cols-12 md:gap-14">
          <div className="md:col-span-4">
            <Reveal>
              <Eyebrow>Turmeric grade guide</Eyebrow>
            </Reveal>
            <ScrollLines
              className="mt-6 block"
              lineClassName="font-serif text-4xl font-medium leading-[1.05] text-bone sm:text-5xl"
              lines={['What the grade', 'means for you.']}
            />
            <Reveal delay={0.2} className="mt-8 max-w-sm text-sm leading-relaxed text-dune md:text-base">
              <p>
                Same rhizome, five finishes. The grade sets how the finger looks, how much it weighs
                after processing, and which markets it clears. Tell us your end use — we’ll match the
                grade to it.
              </p>
            </Reveal>
          </div>

          <div className="md:col-span-8">
            <ol className="divide-y divide-white/10 border-y border-white/10">
              {TURMERIC_GRADES.map((g, i) => (
                <Reveal key={g.name} delay={0.06 * i}>
                  <li className="grid gap-4 py-8 md:grid-cols-12 md:gap-8" data-testid={`grade-${g.name.toLowerCase().replace(/\s+/g, '-')}`}>
                    <div className="md:col-span-4">
                      <span className="font-serif text-lg italic text-turmeric/80">0{i + 1}</span>
                      <h3 className="mt-2 font-serif text-2xl font-medium text-bone md:text-3xl">{g.name}</h3>
                      <p className="mt-1 text-[11px] uppercase tracking-[0.24em] text-dune">{g.short}</p>
                    </div>
                    <div className="md:col-span-8">
                      <p className="text-sm leading-relaxed text-bone/80 md:text-base">{g.body}</p>
                      <p className="mt-4 text-[12px] leading-relaxed text-dune">
                        <span className="text-turmeric">Best fit —</span> {g.fit}
                      </p>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
